






















import { Vue, Component, Watch } from 'vue-property-decorator'
import layoutStore from '@/modules/shared/layout.store'
import { isDownloadingUpdates, quitAndInstall } from '@/utils/autoUpdate'
import { getModule } from 'vuex-module-decorators'
import { isElectron } from '@/utils/electron'

@Component
export default class UpdateDialog extends Vue {
  layoutModule = getModule(layoutStore, this.$store)
  shouldVisible: boolean = false
  timer: NodeJS.Timeout | null = null
  toastError: Function | null = null

  @Watch('progress')
  onProgressUpdate(progress: number) {
    if (progress > 0) this.shouldVisible = true
  }

  @Watch('isVisible')
  onVisibilityChanged(visible: boolean) {
    if (visible) {
      // disable error toast
      this.toastError = this.$toast.error as Function
      ;(this.$toast as any).error = function() {}
    } else if (this.toastError) {
      // restore error toast function
      ;(this.$toast as any).error = this.toastError
      this.toastError = null
    }
  }

  async created() {
    if (await isDownloadingUpdates()) {
      this.shouldVisible = true
    }

    this.timer = setInterval(this.onTick, 10 * 1000)
  }

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer as NodeJS.Timeout)
      this.timer = null
    }
  }

  get isVisible() {
    return this.shouldVisible || !!this.layoutModule.updateDownloadProgress
  }

  get progress() {
    if (!this.layoutModule.updateDownloadProgress) {
      return 0
    }

    return this.layoutModule.updateDownloadProgress.percent
  }

  async onTick() {
    if (!isElectron() || !this.isVisible) {
      return
    }

    if (!(await isDownloadingUpdates())) {
      clearInterval(this.timer as NodeJS.Timeout)
      this.timer = null

      // relaunch app
      await window.ipcRenderer.send('relaunch')
    }
  }
}
